import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { ResponsiveImage, ReviewRating } from "@quintype/components";
import { HeroImageCaption } from "../elements/image-caption";
import styles from "./styles.m.css";
import { getStoryData } from "../../../../../utils/utils";

const ReviewHeroImageWithRating = ({ story, className = "" }) => {
  const imageData = getStoryData(story, false);
  let ratingValue = get(story, ["metadata", "review-rating", "value"], 0);
  const ratingTitle = get(story, ["metadata", "review-title"], "திரைப்பட மதிப்பீடு");
  return (
    <div className={`${styles["hero-image-8x5"]} ${className}`}>
      <figure className={`${styles["image-wrapper"]} qt-figure`}>
        <ResponsiveImage
          eager
          slug={imageData.imageS3Key}
          metadata={imageData.imageMetadata}
          alt={imageData.imageCaption}
          aspectRatio={[8, 5]}
          defaultWidth={480}
          widths={[320, 500, 680]}
          sizes="(max-width: 1024px) 100vw, 70vw"
          imgParams={{ auto: ["format", "compress"] }}
        />
      </figure>
      <div className={styles.review}>
        <h4 className={styles["review-label"]}>{ratingTitle}</h4>
        <ReviewRating value={ratingValue} canShowEmptyRating={true} />
      </div>
    </div>
  );
};

ReviewHeroImageWithRating.propTypes = {
  className: PropTypes.string,
  reviewLabel: PropTypes.string,
  ratingTitle: PropTypes.string,
  story: PropTypes.shape({
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    "hero-image-metadata": PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      "mime-type": PropTypes.string,
      "focus-point": PropTypes.arrayOf(PropTypes.number)
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          "hero-image": PropTypes.shape({
            "hero-image-metadata": PropTypes.shape({
              "mime-type": PropTypes.string
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      })
    })
  })
};

const LongFormHeroImage = ({ story, className = "" }) => {
  const storyData = getStoryData(story, false);

  return (
    <div className={`${styles["hero-image-24x7"]} ${className}`}>
      <figure className={`${styles["image-wrapper"]} qt-figure`}>
        <ResponsiveImage
          eager
          slug={storyData.imageS3Key}
          metadata={storyData.imageMetadata}
          alt={storyData.imageCaption}
          aspectRatio={[24, 7]}
          defaultWidth={480}
          widths={[320, 500, 700]}
          sizes="(max-width: 1024px) 100vw, 70vw"
          imgParams={{ auto: ["format", "compress"] }}
        />
      </figure>
    </div>
  );
};

LongFormHeroImage.propTypes = {
  className: PropTypes.string,
  story: PropTypes.shape({
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    "hero-image-metadata": PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      "mime-type": PropTypes.string,
      "focus-point": PropTypes.arrayOf(PropTypes.number)
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          "hero-image": PropTypes.shape({
            "hero-image-metadata": PropTypes.shape({
              "mime-type": PropTypes.string
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      })
    })
  })
};

const HeroImage = ({ story, className = "" }) => {
  const storyData = getStoryData(story, false);
  if (storyData.hasOwnProperty("imageS3Key") && storyData.imageS3Key) {
    return (
      <div className={`${styles["hero-image"]} ${className}`}>
        <figure className={`${styles["image-wrapper"]} qt-figure`}>
          <ResponsiveImage
            eager
            slug={storyData.imageS3Key}
            metadata={storyData.imageMetadata}
            alt={storyData.imageCaption}
            aspectRatio={[16, 9]}
            defaultWidth={480}
            widths={[320, 500, 700]}
            sizes="(max-width: 1024px) 100vw, 70vw"
            imgParams={{ auto: ["format", "compress"] }}
          />
        </figure>
        <HeroImageCaption storyData={storyData} />
      </div>
    );
  } else {
    return null;
  }
};

HeroImage.propTypes = {
  className: PropTypes.string,
  story: PropTypes.shape({
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    "hero-image-metadata": PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      "mime-type": PropTypes.string,
      "focus-point": PropTypes.arrayOf(PropTypes.number)
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          "hero-image": PropTypes.shape({
            "hero-image-metadata": PropTypes.shape({
              "mime-type": PropTypes.string
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      })
    })
  })
};

export { HeroImage, LongFormHeroImage, ReviewHeroImageWithRating };
